import { setup_ajax } from "./helpers";
setup_ajax();

var author_template = require("./../templates/sidebar-author.handlebars");

var INITIAL_COUNT = 7;

// Populates the left-sidebar authors card on the home feed. Logged-out
// visitors see the curated popular authors (the same set used in onboarding);
// logged-in users see the writers they follow, most recently active first,
// with an "unseen" dot on writers who posted since they last checked. One
// container with a data-source attribute decides which feed to pull.
$(function () {
  var $target = $(".js-sidebar-authors");
  if (!$target.length) {
    return;
  }

  var source = $target.data("source");
  var url;
  var extract;
  if (source === "following") {
    url =
      "/api/user/following?order=recent&username=" +
      encodeURIComponent($target.data("username"));
    extract = function (data) {
      return data || [];
    };
  } else {
    url = "/api/users/suggestions?onboarding=true";
    extract = function (data) {
      return (data && data.featured) || [];
    };
  }

  function hideCard() {
    $("#sidebar-authors-card").addClass("hidden");
  }

  function render(authors) {
    for (var i = 0; i < authors.length; i++) {
      var $row = $(author_template(authors[i]));
      if (i >= INITIAL_COUNT) {
        $row.addClass("js-sidebar-author-extra hidden");
      }
      $target.append($row);
    }
    if (authors.length > INITIAL_COUNT) {
      addToggle();
    }
  }

  function addToggle() {
    var expanded = false;
    var $toggle = $(
      '<button type="button" class="js-sidebar-authors-toggle block mt-2 px-2 py-1 text-xs font-semibold" style="color: #4338ca;">Show more</button>'
    );
    $toggle.on("click", function () {
      expanded = !expanded;
      $target.find(".js-sidebar-author-extra").toggleClass("hidden", !expanded);
      $toggle.text(expanded ? "Show fewer" : "Show more");
    });
    $target.after($toggle);
  }

  $.ajax({
    type: "GET",
    url: url,
    success: function (data) {
      var authors = extract(data);
      if (!authors.length) {
        hideCard();
        return;
      }
      render(authors);
    },
    error: hideCard,
  });
});
